<template>
  <middle-modal
    title="Sind Sie sicher, dass die Person die Prüfung bestanden hat?"
    :isVisible="isVisible"
    @closeModal="closeFunction()"
  >
    <h3 class="text-grey text-center mt-2 mb-8">
      Nach Bestätigen dieser Aktion erhält die Person ihr Zertifikat.
    </h3>

    <div class="flex flex-row justify-between w-full">
      <custom-button
        @click="closeFunction()"
        class="w-36 h-11"
        text="Abbrechen"
        :bgColor="'bg-black'"
        :textColor="'text-white'"
        :id="'cancel-pass-exam-button'"
      />
      <custom-button
        @click="UPDATE_PARTICIPANT_EXAM_STATUS"
        class="w-36 h-11"
        text="Bestätigen"
        :bgColor="'bg-primary'"
        :textColor="'text-white'"
        :id="'contact-pass-exam-button'"
      />
    </div>
  </middle-modal>
</template>

<script>
import { computed, defineComponent } from "vue";
import { useStore } from "vuex";
import { getData } from "../../common/dataHelper";
import CustomButton from "../../components/input/CustomButton.vue";
import MiddleModal from "../../components/layout/MiddleModal.vue";
import { HELPER_TYPES, LECTURER_TYPES, STORE_TYPES } from "../../store/types";

export default defineComponent({
  components: { CustomButton, MiddleModal },
  name: "ContactPassExamModal",
  emits: ["close"],
  props: {
    participantId: {
      required: true,
    },
    courseId: {
      required: true,
    },
    isVisible: {
      type: Boolean,
      required: true,
    },
  },

  setup(props, ctx) {
    const store = useStore();

    function closeFunction() {
      ctx.emit("close");
    }

    async function UPDATE_PARTICIPANT_EXAM_STATUS() {
      store.commit(
        `${STORE_TYPES.HELPERS}/${HELPER_TYPES.SET_LOADING_ID}`,
        "contact-pass-exam-button"
      );

      GET_SELECTED_PARTICIPANT.value.exam_passed = true;
      const response = await store.dispatch(
        `${STORE_TYPES.LECTURER_COURSES}/${LECTURER_TYPES.UPDATE_PARTICIPANT_EXAM_STATUS}`,
        {
          courseId: props.courseId,
          customerId: props.participantId,
          examPassed: true,
        }
      );
      store.commit(
        `${STORE_TYPES.HELPERS}/${HELPER_TYPES.REMOVE_LOADING_ID}`,
        "contact-pass-exam-button"
      );

      if (getData(response, "status") == 200) {
        closeFunction();
      } else {
        GET_SELECTED_PARTICIPANT.value.exam_passed = false;
      }
    }

    const GET_PARTICIPANTS = computed(() => {
      return store.getters[
        `${STORE_TYPES.LECTURER_COURSES}/${LECTURER_TYPES.GET_PARTICIPANTS}`
      ];
    });

    const GET_SELECTED_PARTICIPANT = computed(() => {
      return GET_PARTICIPANTS.value.find(
        (participant) => participant.id === props.participantId
      );
    });

    return { closeFunction, UPDATE_PARTICIPANT_EXAM_STATUS };
  },
});
</script>
